<button
  class="btn btn-neutral btn-block"
  appDisableOutsideElectron
  [swal]="quitSwal"
  appAnalyticsClick="Meta:Quit"
  appSfx="ui-error"
  [sfxTrigger]="['hover', 'click']"
>
  Quit
</button>

<swal
  #quitSwal
  title="Quit re:Form Kingdom?"
  text="Boo will miss you!"
  icon="warning"
  confirmButtonText="Yes, quit game"
  cancelButtonText="No, cancel"
  (confirm)="meta.quit()"
></swal>
